import {
  EntityType,
  WorkflowCode,
  type CreateTaskAndSubtasksInput,
} from '@exam-management/graphql';

import type { QSetReviewTaskCreationFormInput } from '../../schemas';

export function createTaskAndSubtasksMapper(
  formData: QSetReviewTaskCreationFormInput,
  ownerId: string,
) {
  const assigneeId = formData.taskDetails.assignee.value;
  const createTaskAndSubtasksInput: CreateTaskAndSubtasksInput = {
    assigneeId: formData.taskDetails.assignTo === 'DELEGATED' ? assigneeId : ownerId,
    ownerId: ownerId,
    name: formData.taskDetails.name,
    dueDate: formData.taskDetails.dueDate,
    entityId: formData.examCourseSelection.examCourse.value,
    entityType: EntityType.ExaminationCourse,
    workflowCode: WorkflowCode.ReviewQSet,
    assignerId: ownerId,
    subtasks: formData.qsetSelection.qsetId.map((id) => ({
      entityId: id,
      entityType: EntityType.Qset,
      assigneeId: assigneeId,
    })),
  };
  return createTaskAndSubtasksInput;
}
